module.exports = __webpack_public_path__ + "static/media/classev40.ae26948b.png";